var angular=window.angular,ngModule;
try {ngModule=angular.module(["views"])}
catch(e){ngModule=angular.module("views",[])}
var v1="<div class=\"ibox list-tags\"><div class=\"ibox-title\"><h5>{{::$ctrl.title || 'Tags'}}</h5><div class=\"ibox-tools\" ng-if=\"::!$ctrl.preventEdit\"><a ng-click=\"$ctrl.editTags()\"><i class=\"fa fa-edit fa-lg\" aria-hidden=\"true\"></i></a></div></div><div class=\"ibox-content\"><tags-viewer ng-model=\"$ctrl.tags\" tag-kinds=\"$ctrl.tagKinds\"></tags-viewer></div></div>";
var id1="tags-ibox.htm";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;